import { TokenService } from './token.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegistroComponent } from './registro/registro.component';
import { RegistroContadorComponent } from './registro-contador/registro-contador.component';
import { RegistroJucespComponent } from './registro-jucesp/registro-jucesp.component';
import { InscricoesTributariasComponent } from './inscricoes-tributarias/inscricoes-tributarias.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'integrador', component: DashboardComponent },

  { path: 'login', component: DashboardComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [TokenService] },
  { path: 'registro', component: RegistroComponent, canActivate: [TokenService] },
  { path: 'registro-jucesp', component: RegistroJucespComponent, canActivate: [TokenService] },
  { path: 'registro-contador', component: RegistroContadorComponent },
  { path: 'integrador/registro-contador', component: RegistroContadorComponent },
  { path: 'inscricoes-tributarias', component: InscricoesTributariasComponent, canActivate: [TokenService] }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
